// @ vendor
const get = require('lodash/object/get');

// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const { AGENT_INFO } = require('constants/session');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');
const Storage = require('utilities/storage');
const { isDisasterRecoveryMode } = require('utilities/contactCenter/disasterRecoveryhelper');
const usd = require('utilities/usd');

const requestConfiguration = () => ({
    type: actionTypes.PASSWORD_POSITIONS_CONFIG_REQUEST
});

const requestConfigurationSuccess = response => {
    const passwordLength = parseInt(get(response, 'passwordLength', 0));

    return ({
        type: actionTypes.PASSWORD_POSITIONS_CONFIG_REQUEST_SUCCESS,
        payload: {
            passwordLength: Number.isNaN(passwordLength) ? 0 : passwordLength,
            requiredDigits: get(response, 'positions', null)
        }
    });
};

const requestConfigurationFailure = response => ({
    type: actionTypes.PASSWORD_POSITIONS_CONFIG_REQUEST_FAILURE,
    payload: {
        message: response
    }
});

const processRequestConfiguration = (documentType, documentNumber) => (dispatch) => {
    dispatch(requestConfiguration());

    let bankToken;

    if (isDisasterRecoveryMode()) {
        const agentInfo = JSON.parse(Storage.cookies.get(AGENT_INFO));
        bankToken = agentInfo.bankToken;
    } else {
        bankToken = usd.getAgentToken();
    }

    const params = {
        query: {
            bankToken,
            documentType: documentType,
            document: documentNumber
        }
    };

    return APIPost({ dispatch, endpoint: 'getPasswordPositions', params })
        .then(responseSuccess => dispatch(requestConfigurationSuccess(responseSuccess)))
        .catch(responseFailure => {
            dispatch(requestConfigurationFailure(responseFailure));
            throw responseFailure;
        });
};

const reset = () => ({
    type: actionTypes.PASSWORD_POSITIONS_RESET
});

module.exports = {
    processRequestConfiguration,
    reset
};
